import { render, staticRenderFns } from "./HeaderToxis.vue?vue&type=template&id=452ae548&lang=pug&"
import script from "./HeaderToxis.vue?vue&type=script&lang=js&"
export * from "./HeaderToxis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports